import LayerDescription from "./LayerDescription";
import TileTemplate from "./TileTemplate";
import TileTypeBackground from "./TileTypeBackground";

export default class TileType {
    /**
     * @param {string} id
     * @param {string} name
     * @param {string} iconFileName
     * @param {boolean} opaque 
     * @param {boolean} lightingSupported
     * @param {number} tileTypeRarity See TileTypeRarity
     */
    constructor(id, name, iconFileName, opaque, lightingSupported, tileTypeRarity) {
        /**
         * @constant
         * @type {string}
         */
        this.id = id;
        /**
         * @constant
         * @type {string}
         */
        this.name = name;
        /**
         * @constant
         * @type {string}
         */
        this.iconFileName = iconFileName;

        /**
         * @constant
         * @type {boolean}
         */
        this.opaque = opaque;
        /**
         * @constant
         * @type {boolean}
         */
        this.lightingSupported = lightingSupported;

        /**
         * @constant
         * @type {number}
         */
        this.rarityModifier = tileTypeRarity;

        /**
         * @type {TileTemplate}
         */
        this.tileTemplate = null;
        /**
         * @type {TileTemplate}
         */
        this.tileTemplate2 = null;
        /**
         * @type {TileTemplate}
         */
        this.tileTemplate3 = null;

        /**
         * @type {TileTypeBackground}
         */
        this.tileTypeBackground = null;

        /**
         * The backpointer to the layer that the tile is a part of.
         * @type {LayerDescription}
         */
        this.layerDescription = null;

        /**
         * @type {string}
         */
        this.openColor = '';
        /**
         * @type {string}
         */
        this.closedColor = '';
    }

    /**
     * @returns {TileTemplate}
     */
    getRandomTemplate() {
        const r = Math.random();
        if (r < 0.333) {
            return this.tileTemplate;
        }
        else if (r < 0.666) {
            return this.tileTemplate2;
        }
        else {
            return this.tileTemplate3;
        }
    }
}